import {
  IconeAtividade,
  IconeAudio,
  IconeAvisos,
  IconeConfiguracoes,
  IconeContas,
  IconeMaquinas,
  IconeSaude,
  IconeToolkit,
  IconeTrabalho,
  IconeUso,
} from '../componentes/icones';

export type IconeDePagina = (props: {
  tamanho?: number;
  className?: string;
}) => React.JSX.Element;

export interface PaginaDoPainel {
  id: string;
  rotulo: string;
  Icone: IconeDePagina;
  rota: string;
  soAdmin?: boolean;
}

/**
 * As telas do painel, numa lista só.
 *
 * Vale para o computador e para o celular. Estava só no `Shell`, que é a
 * moldura do desktop — e foi por isso que o celular ficou sem caminho para
 * Avisos: quem chegava pelo telefone via três abas (sessões, conversa,
 * permissões) e nenhuma porta para o resto do site.
 */
export const PAGINAS: PaginaDoPainel[] = [
  { id: 'trabalho', rotulo: 'Trabalho', Icone: IconeTrabalho, rota: '/' },
  { id: 'audio', rotulo: 'Áudio', Icone: IconeAudio, rota: '/audio' },
  { id: 'maquinas', rotulo: 'Máquinas', Icone: IconeMaquinas, rota: '/maquinas' },
  { id: 'uso', rotulo: 'Uso', Icone: IconeUso, rota: '/uso' },
  /*
    O Toolkit (F3.7) é de todo papel: LEITOR lê o catálogo (o recorte é o
    `veOItem` da API) e só não vê os botões de decidir — quem recusa é a API.
  */
  { id: 'toolkit', rotulo: 'Toolkit', Icone: IconeToolkit, rota: '/toolkit' },
  { id: 'avisos', rotulo: 'Avisos', Icone: IconeAvisos, rota: '/notificacoes' },
  { id: 'contas', rotulo: 'Contas', Icone: IconeContas, rota: '/usuarios', soAdmin: true },
  { id: 'atividade', rotulo: 'Atividade', Icone: IconeAtividade, rota: '/atividade', soAdmin: true },
  { id: 'saude', rotulo: 'Saúde', Icone: IconeSaude, rota: '/admin/saude', soAdmin: true },
  {
    id: 'configuracoes',
    rotulo: 'Configurações',
    Icone: IconeConfiguracoes,
    rota: '/admin/configuracoes',
    soAdmin: true,
  },
];

export interface RecursosDoServidor {
  transcricao?: boolean;
  arquivos?: boolean;
  notificacoes?: boolean;
  /** A seção de Áudio no menu; separada do provedor de transcrição. */
  abaAudio?: boolean;
  /** O OpenCode, terceiro motor (F17): `RECURSO_OPENCODE` na API (D32). */
  opencode?: boolean;
}

/**
 * O que esta pessoa, nesta instalação, pode ver no menu.
 *
 * `recursos?.x === false` e não `!recursos?.x`: uma resposta sem o campo — API
 * antiga, proxy que cortou o corpo — não pode apagar o menu inteiro. O menu é a
 * última coisa que some quando algo dá errado.
 */
export function paginasVisiveis(
  papel: string | undefined,
  recursos: RecursosDoServidor | undefined,
): PaginaDoPainel[] {
  return PAGINAS.filter((pagina) => {
    if (pagina.soAdmin && papel !== 'ADMIN') return false;
    if (pagina.id === 'audio' && recursos?.transcricao === false) return false;
    /**
     * A aba dedicada de Áudio some por configuração, e isso **não** desliga o
     * ditado: quem governa o microfone do compositor continua sendo
     * `recursos.transcricao`. São duas perguntas diferentes — "existe provedor
     * de transcrição?" e "esta instalação quer uma seção de áudio no menu?" — e
     * juntá-las tiraria o microfone de quem só queria arrumar o menu.
     */
    if (pagina.id === 'audio' && recursos?.abaAudio === false) return false;
    if (pagina.id === 'avisos' && recursos?.notificacoes === false) return false;
    /**
     * A exceção à regra do `=== false`, e ela é de propósito: aqui a AUSÊNCIA
     * esconde. O campo `opencode` nasceu junto com as rotas da tela — uma API
     * que não o manda é anterior à F17, e as rotas de Configurações nem
     * existem nela. Mostrar o item seria oferecer uma tela que só responde 404.
     * E o recurso nasce desligado em produção (D32): o menu acompanha a API.
     */
    if (pagina.id === 'configuracoes' && recursos?.opencode !== true) return false;
    return true;
  });
}
